import React from 'react';
import style from './RightSide.module.scss';
import {Map, Marker, NavigationControl, InfoWindow,MarkerList} from 'react-bmap'
import Close from "../../image/icon/cloose.png";
import $ from  'jquery';
class RightSide extends React.Component {
  constructor(props) {
      var r = document.documentElement;
      var a =parseInt(r.getBoundingClientRect().width);//获取当前设备的宽度
    super(props);
    this.state = {
        company:"",
        name:"",
        email:"",
        orders:"",
        MobileWith:a,
        isMobile:false,
        data:null
    }
      this.compnayChange = this.compnayChange.bind(this);
      this.nameChange = this.nameChange.bind(this);
      this.emailChange = this.emailChange.bind(this);
      this.ordersChange = this.ordersChange.bind(this);

  }
    componentDidMount () {
        window.addEventListener("resize",this.indexChange.bind(this));
        var that=this;
        $.ajax({
            type:'get',
            url:'/home/home.json',
            success:function (data) {
                that.setState({
                    data:data
                })
            }
        })
        this.indexChange();
    }
    componentWillUnmount(){
        window.removeEventListener('resize',this.indexChange)
    }
    indexChange(){
        this.setState({isMobile: window.innerWidth <= 760});
    }

    compnayChange(event) {
        this.setState({
            company: event.target.value.toString()
        });
    }
    nameChange(event) {
        this.setState({
            name:event.target.value.toString()
        });
    }
    emailChange(event) {
        this.setState({
            email:event.target.value.toString()
        });
    }
    ordersChange(event) {
        this.setState({
            orders:event.target.value.toString()
        });
    }
    inpuSubmit=()=>{
        var appid="13158"
        var subject="来自壹墨官网的邮件"
        var text="【壹墨官网】公司名称:"+this.state.company+";"+
            "姓名:"+this.state.name+";"+
            "邮件:"+this.state.email+";"+
            "合作意向:"+this.state.orders

        var email="18721931141"
        console.log("company==="+this.state.company)
        console.log("name==="+this.state.name)
        console.log("email==="+this.state.email)
        console.log("orders==="+this.state.orders)
        if (!this.state.company){
            alert("公司名称不能为空!")
            return
        }else if(!this.state.name){
            alert("姓名不能为空!")
            return;
        }else if (!this.state.email){
            alert("邮件不能为空!")
            return;
        }else if(!this.state.orders){
            alert("请输入您的合作意向")
            return;
        }else{
            $.ajax({
                url:'https://api.mysubmail.com/message/send',
                type:"POST",
                data :{
                    "appid":"42649",
                    "to":"130031522779",
                    "content":text,
                    "signature":"27ce3a1806961df7bc52a5c7fc5cbc00"
                },
                success:function (result) {
                    console.log("msg"+result)
                   alert("提交成功!")
                },
                error:function(msg){
                   if (msg.readyState==0){
                       alert("提交成功!")
                   }else{
                       alert("提交失败")
                   }
                }
            })
            $.ajax({
                url: 'https://api.mysubmail.com/mail/xsend',
                type: 'POST',
                data: {
                    "appid":"15159",
                    "to":"Richard.yan@eyemove.net",
                    "project":"gk07F2",
                    "signature":"b06b200ed82f392a7c45362df2f7ea8b",
                    "vars":{
                        "company":this.state.company,
                        "name":this.state.name,
                        "email":this.state.email,
                        "orders":this.state.orders
                    }
                },
                success:function (result) {
                    console.log("email"+result)
                },
                error:function (msg) {
                    console.log(msg)
                }
            })
        }

    }
    closeState=()=>{
        this.props.close();
    }
    render() {
      var sty={height:"100%"}
      if(this.state.isMobile){
          return (
          this.state.data!==null?
            <div  className={this.props.rightState?style.rightSide_show+" "+style.rightSide:style.rightSide_hidden+" "+style.rightSide}>
                <div className={style.info_container}>
                    <div className={style.right}>
                        <div className={style.info_ch}>
                            <div className={style.title}>联系我们</div>
                            <div>{this.state.data.rightSide.mobile.ch.Business_contact}</div>
                            <div>{this.state.data.rightSide.mobile.ch.Business_email}</div>
                            <div>{this.state.data.rightSide.mobile.ch.Telephone_exchange}</div>
                            <div>{this.state.data.rightSide.mobile.ch.Fax}</div>
                            <div>{this.state.data.rightSide.mobile.ch.Production_center}</div>
                            <div>{this.state.data.rightSide.mobile.ch.Design_center}</div>
                        </div>
                        <div className={style.info_en}>
                            <div className={style.title}>Contact</div>
                            <div>{this.state.data.rightSide.mobile.en.Business_contact}</div>
                            <div>{this.state.data.rightSide.mobile.en.Business_email}</div>
                            <div>{this.state.data.rightSide.mobile.en.Telephone_exchange}</div>
                            <div>{this.state.data.rightSide.mobile.en.Fax}</div>
                            <div>{this.state.data.rightSide.mobile.en.Production_center}</div>
                            <div>{this.state.data.rightSide.mobile.en.Design_center}</div>
                        </div>

                            <div className={style.map}>
                            <Map style={sty} center={{lng: 121.429, lat: 31.32544}} zoom="12" >
                                {/*<Marker position={{lng: 121.43039, lat: 31.32544}}/>*/}
                                <MarkerList
                                    data={[
                                        {
                                            text: "壹墨总部",
                                            location: "121.430376,31.325429"
                                        },
                                        {
                                            text: "壹墨创意中心",
                                            location: "121.452636,31.324784"
                                        }

                                    ]}
                                    fillStyle="#ff3333"
                                    animation={true}
                                    isShowShadow={false}
                                    multiple={true}
                                    autoViewport={true}
                                />
                            </Map>
                        </div>
                    </div>
                    <div className={style.left}>
                        <div className={style.input_company}>
                            <p><strong>公司名称(your company)</strong></p>
                            <input type="text" value={this.state.company} onChange={this.compnayChange}/>
                        </div>
                        <div className={style.input_name}>
                            <p><strong>姓名(your name)</strong></p>
                            <input type="text" value={this.state.name} onChange={this.nameChange}/>
                        </div>
                        <div className={style.input_email}>
                            <p><strong>邮箱(your email)</strong></p>
                            <input type="text" value={this.state.email} onChange={this.emailChange}/>
                        </div>
                        <div className={style.input_orders}>
                            <p><strong>合作与建议(Cooperation and suggestions)</strong></p>
                            <input type="text" value={this.state.orders} onChange={this.ordersChange}/>
                        </div>
                        <div className={style.submit} onClick={(e)=>this.inpuSubmit(e)}>提交(submit)</div>
                    </div>
                </div>
                <img src={Close} alt="" onClick={(e)=>this.closeState(e)}/>

            </div>:""
    );}
      else{
          return (
              this.state.data!==null?
              <div  className={this.props.rightState?style.rightSide_show+" "+style.rightSide:style.rightSide_hidden+" "+style.rightSide}>
                  <div className={style.info_container}>
                      <div className={style.left}>
                          <div className={style.left_title}>咨询与建议</div>
                          <div className={style.input_company}>
                              <p><strong>公司名称(your company)</strong></p>
                              <input type="text" value={this.state.company} onChange={this.compnayChange}/>
                          </div>
                          <div className={style.input_name}>
                              <p><strong>姓名(your name)</strong></p>
                              <input type="text" value={this.state.name} onChange={this.nameChange}/>
                          </div>
                          <div className={style.input_email}>
                              <p><strong>邮箱(your email)</strong></p>
                              <input type="text" value={this.state.email} onChange={this.emailChange}/>
                          </div>
                          <div className={style.input_orders}>
                              <p><strong>合作与建议(Cooperation and suggestions)</strong></p>
                              <input type="text" value={this.state.orders} onChange={this.ordersChange}/>
                          </div>
                          <div className={style.submit} onClick={(e)=>this.inpuSubmit(e)}>提交(submit)</div>
                      </div>
                      <div className={style.right}>
                          <div className={style.title}>联系我们</div>
                          <div><strong>业务联系电话(Business contact):</strong>{this.state.data.rightSide.pc.Business_contact}</div>
                          <div><strong>业务联系邮箱(Business email):</strong>{this.state.data.rightSide.pc.Business_email}</div>
                          <div><strong>公司总机(Telephone exchange):</strong>{this.state.data.rightSide.pc.Telephone_exchange}</div>
                          <div><strong>传真(Fax):</strong>{this.state.data.rightSide.pc.Fax}</div>
                          <div><strong>公司地址(Adress)</strong></div>
                          <div><strong>总部及生产中心(Production Center):</strong>{this.state.data.rightSide.pc.Production_center}</div>
                          <div>{this.state.data.rightSide.pc.Production_center_en}</div>
                          <div><strong>创意及设计中心(Design Center):</strong>{this.state.data.rightSide.pc.Design_center}</div>
                          <div>{this.state.data.rightSide.pc.Design_center_en}</div>
                          <div className={style.map}>
                              <Map  center={{lng: 121.429, lat: 31.32544}} zoom="19" >
                                  <MarkerList
                                      data={[
                                          {
                                              text: "壹墨总部",
                                              location: "121.430376,31.325429"
                                          },
                                          {
                                              text: "壹墨创意中心",
                                              location: "121.452636,31.324784"
                                          }

                                      ]}
                                      fillStyle="#ff3333"
                                      animation={true}
                                      isShowShadow={false}
                                      multiple={true}
                                      autoViewport={true}
                                  />
                                  <NavigationControl />
                                  <InfoWindow position={{lng: 121.43039, lat: 31.32544}} text="上海市宝山区长康路26号 <br/> No.26 ChangKang Road (near Gongkang Road),
                              <br/> Baoshan District, Shanghai" title="<strong>总部及生产中心</strong> <br/> Production Center"/>
                              </Map>
                          </div>
                      </div>
                  </div>
                  <img src={Close} alt="" onClick={(e)=>this.closeState(e)}/>
              </div>:""
          )
      }
  }

}
export default RightSide;
